import { memo, useMemo } from 'react';

type Props = { fileData?: File; fileLink?: string };

const getFileSignature = (file?: File) =>
  file ? `${file.name}|${file.size}|${file.type}|${file.lastModified}` : '';

// Module-level cache: map File object identity to a stable object URL.
// WeakMap ensures entries can be GC'd when File objects are no longer referenced.
const fileToObjectUrl = new WeakMap<File, string>();

const ImageSmallIcon = ({ fileData, fileLink }: Props) => {
  const signature = useMemo(() => getFileSignature(fileData), [fileData]);
  const src = useMemo(() => {
    if (!fileData) return fileLink;
    let url = fileToObjectUrl.get(fileData);
    if (!url) {
      url = URL.createObjectURL(fileData);
      fileToObjectUrl.set(fileData, url);
    }
    return url;
  }, [fileData, fileLink, signature]);

  return (
    <div className="flex items-center justify-center hover:cursor-pointer">
      <img
        src={src}
        className="h-9 w-9 object-cover"
        alt={fileData?.name || 'preview'}
        loading="lazy"
        decoding="async"
        draggable={false}
      />
    </div>
  );
};

export default memo(
  ImageSmallIcon,
  (prev: Readonly<Props>, next: Readonly<Props>) =>
    getFileSignature(prev.fileData) === getFileSignature(next.fileData),
);
